export default "__VITE_ASSET__DDjs6Neg__"